import { useCallback, useState } from 'react';

import { nr } from '~/common';

import { useSecondConsumed, getSecondsCompletionPercent } from '../media-lifecycle-hooks';
import { useMediaPlayer } from '../MediaPlayerProvider';

const LOG_PACE_IN_PERCENTS = 10;
export function useLogConsumption() {
  const { player, mediaId } = useMediaPlayer();

  const [lastLoggedCompletionPercent, setLastLoggedCompletionPercent] = useState<number>(-1);

  const onSecondConsumedHandler = useCallback(() => {
    if (player !== null) {
      const secondsCompletionPercent = getSecondsCompletionPercent(player);
      const isConsumedMore = secondsCompletionPercent > lastLoggedCompletionPercent;
      // log every 10%
      const isEnoughToLog = secondsCompletionPercent % LOG_PACE_IN_PERCENTS === 0;

      if (isConsumedMore && isEnoughToLog) {
        setLastLoggedCompletionPercent(secondsCompletionPercent);
        nr.addAction(nr.BRIGHTCOVE_MEDIA_CONSUMED, { mediaId, percent: secondsCompletionPercent });
      }
    }
  }, [lastLoggedCompletionPercent, mediaId, player]);

  useSecondConsumed(onSecondConsumedHandler);
}
